import { HttpEvent, HttpEventCallbacks, httpGet } from "@/events/eventsDomain";
import { SuggestedCompany } from "@/types/CompanyInfo";

export type SearchApiClient = {
  companySearch: (
    query: string,
    params: HttpEventCallbacks<SuggestedCompany[]>,
  ) => HttpEvent<SuggestedCompany[]>;
};

export const searchApiClient: SearchApiClient = {
  companySearch: (query, params) =>
    httpGet({ url: `/companysearch?q=${encodeURIComponent(query)}`, ...params }),
};
